import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[applyRegex]',  
})

/*
* directiva para permitir solo numeros enteros en un input, también 
* maneja la misma restricción para texto pegado
*/
export class ApplyRegex {
  
  @Input() applyRegex: string;

  constructor(private el: ElementRef) { }

  @HostListener('change', ['$event']) onChange($event) {
    this.applyRegexInput($event);
  }

  @HostListener('keyup', ['$event']) onKeyUp($event) {
    this.applyRegexInput($event);
  }

  private applyRegexInput ( $event ){
    
    // obtener texto actual    
    if (this.applyRegex) {          
      let textoActual = $event.target.value;
      var strFilterRegEx = new RegExp(this.applyRegex, 'gi');
      let textoFiltrado = 
          textoActual.replace(strFilterRegEx, '');
          
      $event.target.value = textoFiltrado;
    }
  }

}